<template>
	<form class="qna-register" @submit.prevent="register">
		<ManagingSection>
			<ManagingBox title="질문 고정">
				<RadioList v-model="isFixed" :radioList="isFixedList" />
			</ManagingBox>
			<ManagingBox title="작성자">
				<SearchBrand
					@change="idBrandChange"
					ref="SearchBrand"
					searcher-placeholder="브랜드명를 입력하세요"
					selected-placeholder="브랜드를 선택해 주세요"
					:use-last-brand="false"
					:show-if-is-display="true"
				/>
			</ManagingBox>
			<ManagingBox title="질문 분야">
				<CategorySelector
					ref="categorySelector"
					@change="onChangeCategory($event, 'targetCategories')"
					:category_level="2"
				/>
			</ManagingBox>
			<ManagingBox title="제목">
				<input type="text" v-model="title" />
			</ManagingBox>
			<ManagingBox title="내용">
				<textarea
					placeholder="내용을 입력해 주세요."
					class="qna-register__textarea"
					v-model="text"
				></textarea>
			</ManagingBox>
			<ManagingBox title="브랜드 태그">
				<div class="qna-register__brand">
					<BrandSelector @change="brandSearch" ref="brandSelector" />
					<button type="button" class="btn" @click="addBrandList">
						추가
					</button>
				</div>
				<ul class="qna-register__brand-tag">
					<li v-for="item in brandList" :key="item.idBrand">
						<span class="qna-register__brand-name"
							>{{ item.name }}
						</span>
						<button
							type="button"
							class="btn-remove black"
							@click="removeBrand(item.idBrand)"
						>
							<i class="fa fa-times-circle"></i>
						</button>
					</li>
				</ul>
			</ManagingBox>
			<ManagingBox title="사진 첨부">
				<ImgListSelector
					v-model="qnaImage"
					:useLink="false"
					:maxLength="5"
				/>
			</ManagingBox>
			<ManagingBox title="연관 제품">
				<div class="qna-register__search-product">
					<ProductSearcher2 @change="searchProduct" />
				</div>
				<table class="table-inner qna-register__table">
					<tr>
						<th class="table-id">제품항번</th>
						<th class="table-img">이미지</th>
						<th class="table-brand">브랜드명</th>
						<th class="table-product">제품명</th>
						<th class="table-display">노출</th>
						<th class="table-discontinued">단종</th>
						<th class="table-remove">제거</th>
					</tr>
					<tr v-if="productList.length === 0">
						<td colspan="7">등록된 제품이 없습니다.</td>
					</tr>
					<tr v-for="item in productList" :key="item.idProduct">
						<td>{{ item.idProduct }}</td>
						<td>
							<figure>
								<img :src="item.filePath" />
							</figure>
						</td>
						<td>{{ item.brandTitle }}</td>
						<td>{{ item.productTitle }}</td>
						<td>
							<span v-if="item.isDisplay">노출</span>
							<span v-else class="red--text">미노출</span>
						</td>
						<td>
							<span v-if="item.isDiscontinue" class="red--text"
								>단종</span
							>
							<span v-else>정상</span>
						</td>
						<td>
							<button
								type="button"
								class="btn-minus"
								@click="removeProduct(item.idProduct)"
							>
								<i class="fa fas fa-minus"></i>
							</button>
						</td>
					</tr>
				</table>
			</ManagingBox>
			<div class="btn-wrap-main">
				<button
					class="btn-main"
					type="button"
					v-text="'취소'"
					@click="$router.go(-1)"
				/>
				<button class="btn-main blue" type="submit" v-text="'등록'" />
			</div>
		</ManagingSection>
	</form>
</template>
<script>
	import ManagingSection from '@/components/layout/ManagingSection.vue';
	import ManagingBox from '@/components/layout/ManagingBox.vue';
	import RadioList from '@/components/RadioList.vue';
	import InputText from '@/components/InputText.vue';
	import SearchBrand from '@/components/SearchBrand.vue';
	import CategorySelector from '@/components/common/CategorySelector';
	import Thumbnail from '@/components/Thumbnail';
	import BrandSelector from '@/components/common/BrandSelector.vue';
	import ProductSearcher2 from '@/components/ProductSearcher2';
	import ImgListSelector from '@/components/ImgListSelector.vue';
	import { getS3Url, uploadS3 } from '@/util';

	export default {
		components: {
			ManagingSection,
			ManagingBox,
			RadioList,
			InputText,
			SearchBrand,
			CategorySelector,
			Thumbnail,
			BrandSelector,
			ProductSearcher2,
			ImgListSelector,
		},
		data() {
			return {
				isFixed: true,
				isFixedList: [
					{ id: true, value: 'Y' },
					{ id: false, value: 'N' },
				],
				imgWidth: 150,
				imgHeight: 50,
				qnaImage: [],
				title: '',
				text: '',
				tags: '',
				officialRefId: null,
				brandList: [],
				productList: [],
				categoryIdList: [],
				doc: {
					qna_image: [],
				},
				brandTarget: null,
			};
		},
		methods: {
			idBrandChange(changes) {
				this.officialRefId = changes.idBrand;
			},
			onChangeCategory(obj) {
				this.categoryIdList = [obj.category2];
			},
			brandSearch(brand) {
				this.brandTarget = brand;
			},
			addBrandList() {
				if (!this.brandTarget) {
					alert('브랜드를 입력해 주세요');
					return;
				}
				if (this.brandList.length === 5) {
					this.$refs.brandSelector.init();
					alert('최대 5개까지 등록이 가능합니다.');
					this.isDisableBrand = true;
					return;
				}
				const hasBrand = this.brandList.some(
					item => item.idBrand === this.brandTarget.idBrand
				);
				if (!hasBrand) {
					this.brandList = [...this.brandList, this.brandTarget];
				} else {
					alert('이미 추가된 브랜드 입니다.');
				}
				this.$refs.brandSelector.init();
			},
			removeBrand(id) {
				const brand = this.brandList.filter(
					item => item.idBrand !== id
				);
				this.brandList = brand;
				this.$refs.brandSelector.init();
			},
			searchProduct(id) {
				if (!id) return;

				const hasProduct = this.productList.some(
					item => item.idProduct === id.idProduct
				);

				const MAX_PRODUCTS = 5;

				if (this.productList.length >= MAX_PRODUCTS) {
					alert('최대 5개까지 등록이 가능합니다.');
					return;
				}

				if (!hasProduct) {
					this.productList = [...this.productList, id];
				} else {
					alert('이미 추가된 제품입니다.');
				}
			},
			removeProduct(id) {
				const product = this.productList.filter(
					item => item.idProduct !== id
				);
				this.productList = product;
			},

			createdParams() {
				return {
					title: this.title,
					text: this.text,
					tags: this.tags,
					officialRefType: 'brand',
					officialRefId: this.officialRefId,
					productIdList: this.productList.map(item => item.idProduct),
					brandIdList: this.brandList.map(item => item.idBrand),
					categoryIdList: this.categoryIdList,
					doc: this.doc,
					isFixed: this.isFixed,
				};
			},

			async uploadAllImages(imgList) {
				try {
					const uploadedImages = await Promise.all(
						imgList.map(async image => {
							const update = await this.getUploadedImgItem(image);
							if (!update) {
								alert('이미지 등록에 실패하였습니다.');
								throw new Error(error);
							}
							return update.src;
						})
					);
					return uploadedImages;
				} catch (error) {
					console.error(error);
					alert('이미지 등록에 실패하였습니다.');
					throw new Error(error);
				}
			},

			async getUploadedImgItem(src) {
				try {
					if (typeof src === 'object') {
						const { data } = await getS3Url(
							src.extension,
							'qna-register'
						);
						await uploadS3(data, src.fileObject);
						src = `${data.fields.key}`;
					}
					return {
						src,
					};
				} catch (err) {
					console.error(err);
				}
			},

			validation() {
				if (!this.officialRefId) {
					alert('작성자를 입력해 주세요.');
					return false;
				}
				if (
					this.categoryIdList.length === 0 ||
					this.categoryIdList[0] === null
				) {
					alert('카테고리를 선택해 주세요.');
					return false;
				}
				if (this.title.trim().length < 5) {
					alert('제목을 최소 5자 이상 입력해주세요.');
					return false;
				}
				if (this.text.trim().length <= 0) {
					alert('내용을 입력해주세요');
					return false;
				}
				return true;
			},

			async register() {
				const params = this.createdParams();

				try {
					if (!this.validation()) {
						return false;
					}
					const uploadeImage = await this.uploadAllImages(
						this.qnaImage
					);
					this.doc.qna_image = [];
					uploadeImage.forEach(key => {
						this.doc.qna_image.push({
							bucket: 'glowpick',
							state: '정상',
							key,
						});
					});
					params.doc = JSON.stringify(this.doc);

					await this.$axiosAdmin2.post('/api/qna', params);
					alert('질문을 등록하였습니다.');
					this.$router.push('/qna/q/list');
				} catch (err) {
					console.error(err);
					if (err.response.data?.message) {
						alert(
							err.response.data?.message ||
								'등록에 실패하였습니다.'
						);
					} else {
						alert('등록에 실패하였습니다.');
					}
				}
			},
		},
	};
</script>
<style lang="scss" , scooped>
	.qna-register {
		&__brand {
			display: flex;
			gap: 5px;
			align-items: center;
		}
		&__textarea {
			height: 300px;
		}
		&__brand-tag {
			display: flex;
			align-items: center;
			gap: 10px;
			margin-top: 15px;

			li {
				display: flex;
				justify-content: center;
				align-items: center;
				gap: 6px;
				border: 1px solid #acaeb4;
				padding: 4px 9px;
				border-radius: 11px;
				font-size: 11px;
				line-height: 22px;
				cursor: default;

				&:hover {
					background-color: #ecf2f8;
				}
			}
		}

		&__brand-name {
			display: block;
		}

		&__search-product {
			width: 1000px;
			margin: 10px 0;
		}

		.table-id,
		.table-img,
		.table-display,
		.table-discontinued,
		.table-remove {
			width: 70px;
		}

		.table-brand {
			width: 200px;
		}
	}
	.red--text {
		color: $red;
	}
</style>
